module.exports = __webpack_public_path__ + "img/imgs12.20150529.png";